import React from 'react';
import proptypes from 'prop-types';
const { arrayOf, func, string, shape } = proptypes;
import { CardMedia, Link, Typography, Button } from '@one-thd/sui-atomic-components';

export const Thumbnails = ({ url, thumbnails }) => {
  const isEmptyProject = thumbnails?.length === 0;
  const EmptyProject = () => {
    return (
      [1, 2, 3].map((number, index) => {
        return (
          <div
            // eslint-disable-next-line tailwindcss/no-arbitrary-value
            className="sui-w-full"
            key={`project-tile-empty-thumbnail-${number}`}
          >
            <div className="sui-w-full sui-bg-strong sui-aspect-square" />
          </div>
        );
      })
    );
  };

  return (
    <Link
      className="sui-w-full sui-h-full"
      href={url}
      data-testid="image-project-link"
    >
      <div className="sui-grid sui-grid-cols-4 sui-gap-2">
        {!isEmptyProject ? (
          [1, 2, 3].map((thumbnailNumber, thumbnailIndex) => {
            const thumbnailUrl = thumbnails?.length >= thumbnailIndex && thumbnails?.[thumbnailIndex];
            return (
              <div
                key={`project-tile-thumbnail-${thumbnailNumber}`}
                className={(thumbnailNumber === 3 && (thumbnails?.length < 3 || thumbnails === null)) ? 'sui-col-span-2' : 'sui-col-span-1'}
              >
                {thumbnailUrl ? (
                  <CardMedia className="sui-w-full sui-aspect-square" src={thumbnailUrl} alt="Product Image" />
                ) : (thumbnailNumber === 3 ? (
                  <div>
                    <Button variant="text">Add Materials</Button>
                  </div>
                )
                  : <div className="sui-w-full sui-bg-strong sui-aspect-square" />
                )}
              </div>
            );
          })
        ) : (
          <EmptyProject />
        )}
      </div>
    </Link>
  );
};

Thumbnails.displayName = 'ProjectTileThumbnails';

Thumbnails.propTypes = {
  url: string.isRequired,
  thumbnails: arrayOf(string),
};

Thumbnails.defaultProps = {
  thumbnails: []
};